export default __webpack_public_path__ + "static/media/credit-card.4ac98573.svg";